import { rows } from './keyboard.data';

interface Button {
  variant: 'outlined' | 'text' | undefined;
}

export class Key {
  html: string;
  value: string;
  disabled: boolean;

  button: Button = {
    variant: 'outlined',
  };

  constructor(html: string, value: string | undefined = undefined, button?: Button, disabled?: boolean) {
    this.html = html;
    this.value = value ?? html;
    this.button = button ?? this.button;
    this.disabled = disabled ?? false;
  }

  setDisabled(disabled: boolean) {
    this.disabled = disabled;
    return this;
  }

  clone() {
    return new Key(this.html, this.value, { variant: this.button.variant }, this.disabled);
  }
}

export class SpecialKey extends Key {
  override value: keyof typeof rows;

  constructor(html: string, value: keyof typeof rows, button?: Button, disabled?: boolean) {
    super(html, value, button, disabled);
    this.value = value;
  }

  override clone() {
    return new SpecialKey(this.html, this.value, { variant: this.button.variant }, this.disabled);
  }
}

export interface KeyboardColumn {
  keys: Key[];
}

export interface KeyboardRow {
  columns: KeyboardColumn[];
}
